import { render, staticRenderFns } from "./storeCount.vue?vue&type=template&id=56c7ff10&scoped=true&"
import script from "./storeCount.vue?vue&type=script&lang=js&"
export * from "./storeCount.vue?vue&type=script&lang=js&"
import style0 from "./storeCount.vue?vue&type=style&index=0&id=56c7ff10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c7ff10",
  null
  
)

export default component.exports